/**
 * AlmadarPostDigitalSovereigntyAlmadarProposalSLAlmadarPostDigitalSovereigntyAlmadarProposalSLPage
 *
 * Page component for AlmadarPostDigitalSovereigntyAlmadarProposalSLAlmadarPostDigitalSovereigntyAlmadarProposalSLPage
 * Path: /sl/blog/digital-sovereignty-almadar-proposal
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageView as __AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageView';
import { AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsView as __AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostDigitalSovereigntyAlmadarProposalSLAlmadarPostDigitalSovereigntyAlmadarProposalSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostDigitalSovereigntyAlmadarProposalSLAlmadarPostDigitalSovereigntyAlmadarProposalSLPage(_props: AlmadarPostDigitalSovereigntyAlmadarProposalSLAlmadarPostDigitalSovereigntyAlmadarProposalSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostDigitalSovereigntyAlmadarProposalSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostDigitalSovereigntyAlmadarProposalSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostDigitalSovereigntyAlmadarProposalSLAlmadarPostDigitalSovereigntyAlmadarProposalSLPage;
